import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
export function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-59">
      {isVisible && <motion.button initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.8
    }} whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} onClick={scrollToTop} className="fixed bottom-8 right-8 z-40 p-3 bg-[#d4a853] text-[#0a1628] shadow-lg hover:bg-white transition-colors duration-300 hidden md:flex items-center justify-center" aria-label="Back to top" data-id="element-60">
          <ArrowUp size={24} data-id="element-61" />
        </motion.button>}
    </AnimatePresence>;
}